<template>
  <div class="component-time-line">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TimeLine'
}
</script>

<style lang="scss">
.component-time-line {
  position: relative;
  &:before {
    border-left: 2px dashed rgba(202, 202, 202, 1);
    content: "";
    display: block;
    position: absolute;
    width: 2px;
    left: 14px;
    top: 46px;
    bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TimeLine/Index.vue